import { render, staticRenderFns } from "./TempAccountType.vue?vue&type=template&id=960ff1b6&scoped=true&"
import script from "./TempAccountType.vue?vue&type=script&lang=js&"
export * from "./TempAccountType.vue?vue&type=script&lang=js&"
import style0 from "./TempAccountType.vue?vue&type=style&index=0&id=960ff1b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960ff1b6",
  null
  
)

export default component.exports